import { createApp } from 'vue'

import searchModal from '~/components/vue/SearchModal.vue'

const searchApp = createApp(searchModal)
//console.log('searchApp', searchApp);
searchApp.mount('#App')

export default searchApp
